module.exports = __webpack_public_path__ + "img/mapping.878ca26d.png";